/** Статусы контента для проверки модератором. */
export const ModerationStatus = {
  PENDING:  'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
} as const;

export type ModerationStatusValue = typeof ModerationStatus[keyof typeof ModerationStatus];
